import React, { ReactElement, useState } from 'react';

import { Moment } from 'moment';

import { DatePickerMode } from '@philips-emr/tws-components-api/lib/constants';
import { CalendarMode } from '@philips-emr/tws-constants';
import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';

import { DatePicker, Popover } from '../..';

import { MonthlyTimeSpan, WeeklyTimeSpan } from '.';

export interface TimeSpanProps {
  date: Moment;
  mode: CalendarMode;
  onArrowClick: (value: number) => void;
  onChange: (value: string) => void;
}

function TimeSpan(props: TimeSpanProps): ReactElement {
  const { date, mode, onArrowClick, onChange } = props;

  const [picker, setPicker] = useState(false);

  const fn = (event: ChangeEvent<string>): void => {
    onChange(event.value);

    setPicker(false);
  };

  return (
    <div className="c-calendar__time-span">
      <div
        className="c-calendar__arrow c-calendar__arrow--prev"
        data-testid="calendar-time-span-arrow-prev"
        onClick={() => onArrowClick(-1)}
      />

      <Popover open={picker} onClose={() => setPicker(false)}>
        <div>
          {mode === CalendarMode.MONTHLY && <MonthlyTimeSpan date={date} onClick={() => setPicker(true)} />}
          {mode === CalendarMode.WEEKLY && <WeeklyTimeSpan date={date} onClick={() => setPicker(true)} />}
        </div>

        <Popover.Content>
          <DatePicker
            mode={DatePickerMode.YEARLY}
            onChange={fn}
            showClear={false}
            showEvents={false}
            value={date.format('YYYY-MM-DD')}
          />
        </Popover.Content>
      </Popover>

      <div
        className="c-calendar__arrow c-calendar__arrow--next"
        data-testid="calendar-time-span-arrow-next"
        onClick={() => onArrowClick(1)}
      />
    </div>
  );
}

export default TimeSpan;
